/*
 * @Author: hujingyang
 * @Date: 2021-01-22 09:36:01
 * @Description: 消耗记录 - 发送明细弹窗
 * @LastEditors: xutingting
 * @LastEditTime: 2021-05-20 10:30:43
 * @FilePath: \DouYinStore\src\pages\AccountKeeper\components\SMSConsumeRecord\components\Dialog_SMSSendDetail\index.tsx
 * @IDE: Created by VScode.
 */

import React, { useEffect, useState } from 'react';
import { Balloon, Button, DatePicker, Dialog, Form, Input, Message, Select, Table } from '@alifd/next';
import style from './index.module.scss';
import LzPagination from '@/components/common/LzPagination';
import moment from 'moment';
import icon_warning from '@/pages/CrowdMarketing/icon/icon-warning.svg';
import utils from '@/common/utils';
import { Servlets } from '@/service';

const FormItem = Form.Item;
const { RangePicker } = DatePicker;
/** 数据弹窗架子 */
const Dialog_SMSSendDetail = (props: any): JSX.Element => {
  const [visible, setVisible] = useState(false);
  const [isLoadingForList, setLoadingForList] = useState(false);// 是否正在加载列表数据
  const [pageTitle, setPageTitle] = useState('');// 当前页标题
  const [searchFormData, setSearchFormData] = useState({} as any);// 搜索表单数据集合
  const [columns, setColumns] = useState([{}]);// 列表title
  const [dataSource, setDataSource] = useState([{}]);// 列表数据

  const [searchFormSetting, setSearchFormSetting] = useState([{}]);// 列表搜索表单配置

  const [pageInfo, setPageInfo] = useState({ pageNo: 1, pageSize: 10, total: 0 }); // 分页数据

  /** 页面数据类型 数据字典 */
  const typeDisc = { marketing: '营销短信', test: '测试短信', orderCare: '订单关怀' };
  const typeDiscText = { marketing: '营销短信发送明细', test: '测试短信发送明细', orderCare: '订单关怀发送明细' };
  const typeApi = {
    营销短信: { list: 'getCrowdDetails', download: 'ExportCrowdSms' },
    测试短信: { list: 'getTestDetails', download: 'ExportTestSms' },
    订单关怀: { list: 'getCareDetails', download: 'ExportCareSms' },
  };

  /** 生命周期函数 */
  useEffect(() => {
    init();
  }, [props]);

  /**
   * 初始化函数
   */
  const init = (): void => {
    if (props.visible) {
      // ["marketing", "test", "orderCare"]
      getPageData();
    }
    setVisible(props.visible);

    setSearchFormData({ ...searchFormData, ...props.searchFormData });

    setPageTitle(typeDiscText[props.sendDetailData.type]);
  };
  /** 获取页面 数据 */
  const getPageData = (): void => {
    setColumns(getColumns(props));
    getDataSource(props).then((res) => {
      setDataSource(res);
    });
    setSearchFormSetting(getSearchFormSetting(props));
  };
  /** 获取列表title */
  const getColumns = (prop: { sendDetailData: { type: string } }): object[] => {
    if (!prop.sendDetailData) {
      return [];
    }

    const { type } = prop.sendDetailData;
    let result = [{}];


    switch (type) {
      case typeDisc.marketing:
        result = [
          {
            title: '发送时间',
            dataIndex: 'date',
            width: 180,
            alignHeader: 'left',
            align: 'left',
          },
          {
            title: '手机号',
            dataIndex: 'receivephone',
            width: 180,
            alignHeader: 'left',
            align: 'left',
          },
          {
            title: '短信内容',
            dataIndex: 'content',
            width: 180,
            alignHeader: 'left',
            align: 'left',
            cell: (value, index, record) => {
              return (<div>
                {
                  (!!value && value.length) > 20 ?
                    <Balloon
                      popupClassName="popupClassName"
                      trigger={<span
                        style={{ cursor: 'pointer' }}
                      >{value.slice(0, 20)}...
                               </span>}
                      closable={false}
                    >
                      {value}
                    </Balloon>
                    :
                    `${value}`
                }
                      </div>);
            },
          },
          {
            title: '字数/计费（条）',
            dataIndex: 'billing',
            width: 180,
            alignHeader: 'left',
            align: 'left',
          },
          {
            title: '发送状态', // 1-成功  0-失败
            dataIndex: 'sendresult',
            width: 180,
            alignHeader: 'left',
            align: 'left',
          },
          {
            title: '备注',
            dataIndex: 'comment',
            width: 180,
            alignHeader: 'left',
            align: 'left',
            cell: (value, index, record) => {
              return (<div>
                {
                  record.sendresult ?
                    <Balloon
                      popupClassName="popupClassName"
                      trigger={<span style={{ cursor: 'pointer' }}>点击查看失败原因</span>}
                      closable={false}
                    >
                      {value}
                    </Balloon>
                    :
                    '--'
                }
                      </div>);
            },
          },

        ];

        break;

      case typeDisc.test:
        result = [
          {
            title: '发送时间',
            dataIndex: 'date',
            width: 180,
            alignHeader: 'left',
            align: 'left',
          },
          {
            title: '营销主题',
            dataIndex: 'theme',
            width: 180,
            alignHeader: 'left',
            align: 'left',
          },
          {
            title: '短信内容',
            dataIndex: 'content',
            width: 180,
            alignHeader: 'left',
            align: 'left',
            cell: (value, index, record) => {
              return (<div>
                {
                  (!!value && value.length) > 20 ?
                    <Balloon
                      popupClassName="popupClassName"
                      trigger={<span
                        style={{ cursor: 'pointer' }}
                      >{value.slice(0, 20)}...
                               </span>}
                      closable={false}
                    >
                      {value}
                    </Balloon>
                    :
                    `${value}`
                }
                      </div>);
            },
          },
          {
            title: '字数/计费（条）',
            dataIndex: 'billing',
            width: 180,
            alignHeader: 'left',
            align: 'left',
          },
          {
            title: <Balloon
              popupClassName="popupClassName"
              trigger={<span style={{ cursor: 'pointer' }}>实际短信消耗量(条)<img
                src={icon_warning}
                alt="提示"
                style={{
                  width: 14,
                  height: 14,
                }}
              />
              </span>}
              closable={false}
            >
              <p>说明</p>
              <p>实际短信消耗量会在活动发送三天后</p>
            </Balloon>,
            dataIndex: 'consume',
            width: 180,
            alignHeader: 'left',
            align: 'left',
          },


        ];
        break;

      case typeDisc.orderCare:
        result = [
          {
            title: '订单号',
            dataIndex: 'orderId',
            width: 180,
            alignHeader: 'left',
            align: 'left',
          },
          {
            title: '任务名称',
            dataIndex: 'name',
            width: 180,
            alignHeader: 'left',
            align: 'left',
          },
          {
            title: '短信内容',
            dataIndex: 'content',
            width: 180,
            alignHeader: 'left',
            align: 'left',
            cell: (value, index, record) => {
              return (<div>
                {
                  (!!value && value.length) > 20 ?
                    <Balloon
                      popupClassName="popupClassName"
                      trigger={<span
                        style={{ cursor: 'pointer' }}
                      >{value.slice(0, 20)}...
                               </span>}
                      closable={false}
                    >
                      {value}
                    </Balloon>
                    :
                    `${value}`
                }
                      </div>);
            },
          },
          {
            title: '字数/计费（条）',
            dataIndex: 'billing',
            width: 180,
            alignHeader: 'left',
            align: 'left',
          },
          {
            title: '催付类型', // 1-首次催付  2-二次催付
            dataIndex: 'type',
            width: 180,
            alignHeader: 'left',
            align: 'left',
            cell: (value, index, record) => {
              return (<div>
                {value === 1 && <span>首次催付</span>}
                {value === 2 && <span>二次催付</span>}
                      </div>);
            },
          },
          {
            title: '发送时间',
            dataIndex: 'date',
            width: 180,
            alignHeader: 'left',
            align: 'left',
          },

          {
            title: '备注',
            dataIndex: 'comment',
            width: 180,
            alignHeader: 'left',
            align: 'left',
            cell: (value, index, record) => {
              return (<div>
                {
                  value ?
                    <Balloon
                      popupClassName="popupClassName"
                      trigger={<span style={{ cursor: 'pointer' }}>点击查看备注</span>}
                      closable={false}
                    >
                      {value}
                    </Balloon>
                    :
                    '--'
                }
                      </div>);
            },
          },

        ];
        break;


      default:
        result = [];
        break;
    }


    return result;
  };

  /** 获取列表数据 */
  const getDataSource = async (prop: { sendDetailData: { type: string } }, searchFormData = {
    pageNo: 1,
    pageSize: 10,
  }): Promise<object[]> => {
    if (!prop.sendDetailData) {
      return [];
    }

    setLoadingForList(true);

    let result = [] as object[];

    await Servlets(typeApi[prop.sendDetailData.type].list, searchFormData).then((res: { data: object[]; page: { pageNo: 1; pageSize: 10; total: 0 } }) => {
      setLoadingForList(false);

      if (res.data) {
        result = res.data;

        setPageInfo(res.page ? res.page : pageInfo);// 设置分页
      }
      /**
       * "data": [
       {
                  "accountSendResult": 0,
                  "activityTitle": "string",
                  "contentLength": 0,
                  "errorMessage": "string",
                  "fullContent": "string",
                  "id": "string",
                  "jdActualNum": 0,
                  "receivePhone": "string",
                  "sendResult": "string",
                  "sendTime": 0,
                  "sendTimePre": "string",
                  "smsSplitNum": 0,
                  "taskTitle": "string"
                }
       ],
       */
    }).catch((err) => {
      console.log(err);
      setLoadingForList(false);/** 关闭loading */
    });

    return result;
  };

  /** 获取列表 搜索表单配置项 */
  const getSearchFormSetting = (prop: { sendDetailData: { type: string } }): object[] => {
    if (!prop.sendDetailData) {
      return [];
    }

    const { type } = prop.sendDetailData;
    let result = [{ prop: '', lable: '', moudle: '', sublist: [{ lable: '', value: '' }] }];


    switch (type) {
      case typeDisc.marketing:
        result = [
          { prop: 'date', lable: '发送时间', moudle: 'date', sublist: [] },
        ];
        break;

      case typeDisc.test:
        result = [
          { prop: 'date', lable: '发送时间', moudle: 'date', sublist: [] },
          { prop: 'receivephone', lable: '发送手机号', moudle: 'input', sublist: [] },
          {
            prop: 'sendresult',
            lable: '发送状态',
            moudle: 'select',
            sublist: [{ lable: 'sendresult_all', value: '全部' }, {
              lable: 'sendresult_sucess',
              value: '成功',
            }, { lable: 'sendresult_fail', value: '失败' }],
          },
        ];
        break;

      case typeDisc.orderCare:
        result = [
          { prop: 'date', lable: '发送时间', moudle: 'date', sublist: [] },
          {
            prop: 'type',
            lable: '催付类型',
            moudle: 'select',
            sublist: [{ lable: '全部', value: 'type_all' }, {
              lable: 'sendresult_first',
              value: '首次催付',
            }, { lable: 'sendresult_second', value: '二次催付' }],
          },
        ];
        break;
      default:
        result = [];
        break;
    }


    return result;
  };

  /** 搜索表单提交时触发 */
  const handleSubmit = (val: any): void => {
    const newSearchForm = {
      receivephone: val.receivephone ? val.receivephone : '',
      sendresult: val.sendresult ? val.sendresult : '',
      type: val.type ? val.type : '',
    };

    const searchForm = {
      ...newSearchForm,
      ...{ // 时间区间处理
        startTime: val.date ? moment(val.date[0] * 1000).unix() : '', // 开始时间 起始
        endTime: val.date ? moment(val.date[1] * 1000).unix() : '', // 结束时间 结束
      },
      ...{ // 分页
        pageNo: 1,
        pageSize: pageInfo.pageSize,
      },
    };
    setSearchFormData(val);

    getDataSource(props, searchForm).then((res) => {
      setDataSource(res);
    });
  };

  // 导出数据
  const downLoadData = (): void => {
    const newSearchForm = {
      receivephone: searchFormData.receivephone ? searchFormData.receivephone : '',
      sendresult: searchFormData.sendresult ? searchFormData.sendresult : '',
      type: searchFormData.type ? searchFormData.type : '',
      startTime: searchFormData.date ? moment(searchFormData.date[0] * 1000).unix() : '', // 开始时间 起始
      endTime: searchFormData.date ? moment(searchFormData.date[1] * 1000).unix() : '', // 结束时间 结束
    };

    Servlets(typeApi[props.sendDetailData.type].download, newSearchForm).then((res: { data }) => {
      if (!res.data) {
        Message.notice('暂无数据');
      }
    })
      .catch((err) => {
        console.log(err);
        setLoadingForList(false);/** 关闭loading */
      });
  };

  /** 搜索表单重置时触发 */
  const handleReset = (): void => {
    setSearchFormData({});
  };

  /** 关闭弹窗触发 */
  const onClose = (): void => {
    setVisible(false);
    props.selected(false);
  };

  /**
   * 翻页方法
   */
  const handlePageSizeChange = async (pages: object = {}): Promise<void> => {
    setLoadingForList(true);

    setPageInfo({ ...pageInfo, ...pages });


    getDataSource(props, {
      ...searchFormData,
      ...{
        startTime: searchFormData.date ? moment(searchFormData.date[0] * 1000).unix() : '', // 开始时间 起始
        endTime: searchFormData.date ? moment(searchFormData.date[1] * 1000).unix() : '', // 结束时间 结束
      },
      ...pages,
    }).then((res) => {
      setDataSource(res);
    });
  };

  return (
    <>
      <section>
        <Dialog
          className="hjy-dialog-SMS"
          title={pageTitle}
          visible={visible}
          footer={false}
          onClose={onClose}
          // {[<Button key="cancel" onClick={onClose} className={`${style.submitBtnStyle_width} ${style.submitBtnStyle_marginRight}`}>关闭</Button>]}
        >
          <div className={style.formAndListStyle}>
            {/* 搜索表单 */}
            <div className={style.listSearch}>
              <Form inline className={style.listSearchForm} size="medium" value={searchFormData}>
                {
                  searchFormSetting.map((item: { prop: string; lable: string; moudle: string; sublist: object[] }, index: number) => {
                    return (
                      <FormItem label={item.lable} className={style.formItem} key={index}>
                        {item.moudle === 'date' &&
                        <RangePicker
                          popupAlign="tr tr"
                          name={item.prop}
                          placeholder="请点选..."
                          className={style.formItem_width320}
                          followTrigger
                          disabledDate={(date, view) => utils.disabledDate(date, view, 'back', false)}
                          showTime
                        />}

                        {item.moudle === 'input' &&
                        <Input
                          name={item.prop}
                          className={style.formItem_width320}
                          placeholder="请输入..."
                          maxLength={100}
                          hasClear
                        />}

                        {item.moudle === 'select' &&
                        <Select
                          placeholder="请点选..."
                          name={item.prop}
                          className={style.formItem_width320}
                          hasClear
                          dataSource={item.sublist}
                          followTrigger
                        />}
                      </FormItem>
                    );
                  })
                }

                <FormItem label="" className={style.formItem}>
                  <Form.Submit
                    className={`${style.submitBtnStyle_width} ${style.submitBtnStyle_marginRight}`}
                    type="primary"
                    onClick={handleSubmit}
                  >查询
                  </Form.Submit>
                  <Form.Reset
                    className={`${style.submitBtnStyle_width} ${style.submitBtnStyle_marginRight}`}
                    onClick={handleReset}
                  >重置
                  </Form.Reset>
                  <Button
                    type="secondary"
                    className={style.submitBtnStyle_width}
                    style={{ marginRight: 6 }}
                    onClick={downLoadData}
                  >导出
                  </Button>
                </FormItem>
              </Form>

            </div>


            {/* 列表 */}
            <div className={style.listContent}>


              <div style={{ marginTop: 8 }}>
                <Table
                  dataSource={dataSource}
                  fixedHeader
                  maxBodyHeight={460}
                  loading={isLoadingForList}
                  columns={columns}
                >
                  {
                    columns.map((item: any, index: number) => {
                      return (
                        <Table.Column
                          title={item.title}
                          key={index}
                          dataIndex={item.dataIndex}
                          cell={item.cell}
                          align={item.align}
                          width={item.width}
                          alignHeader={item.alignHeader}
                          lock={item.lock}
                          htmlTitle={item.htmlTitle}
                        />
                      );
                    })
                  }
                </Table>
              </div>


              {
                !!dataSource.length &&
                <div attr-intro="分页组件" className={[style.Pagination, 'Hjy-Pagination'].join(' ')}>
                  <LzPagination pageInfo={pageInfo} onChange={handlePageSizeChange} />
                </div>
              }
            </div>


          </div>
        </Dialog>
      </section>

    </>
  );
};

export default Dialog_SMSSendDetail;
